import { project2BaseUrl } from './remoteClient'

export async function militaryCategoriesRequest(token) {
        return await project2BaseUrl.get("/administration/getMilitaryCategories", {
            headers: {
                Authorization: `Bearer ${token}`    
        }});
} 